module.exports = __webpack_public_path__ + "img/1_uk.e06fa07b.svg";